import { hc } from "hono/client";
import type { WorkspacesRpc } from "@typedoc/auth/rpc/workspaces";
import { validateApiBase, type RpcFetch } from "./transport";

/**
 * The auth service's workspace routes, which are a different domain from `rpc/workspaces.ts` —
 * that one is the regional API's access check and shares only the word. These read and write the
 * session's organisation and active workspace, so they carry the session cookie.
 */
export function createAuthWorkspacesClient(base: string, fetcher?: RpcFetch) {
  return hc<WorkspacesRpc>(validateApiBase(base), {
    ...(fetcher ? { fetch: fetcher } : {}),
    init: { credentials: "include" },
    headers: { Accept: "application/json" },
  });
}

export type AuthWorkspacesClient = ReturnType<typeof createAuthWorkspacesClient>;
